import formatCurrency from './currency/formatCurrency'

const config = {
  locale: 'nl-NL',
  currency: 'EUR'
}

const parseErrorMessage = error => {
  if (typeof error === 'string') return error
  if (error.response) {
    if (error.response.data) {
      if (error.response.data.error) {
        if (error.response.data.error.message) {
          return error.response.data.error.message
        }
        return error.response.data.error
      }
      return error.response.data
    }
    return error.response
  }
  return error.message
}

export {
  config,
  formatCurrency,
  parseErrorMessage
}
